/**
 * Format date to Thai format
 * @param {Date|string} date 
 * @returns {string} e.g., 1 มกราคม 2569
 */
export const formatThaiDate = (date) => {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  
  const formatter = new Intl.DateTimeFormat('th-TH', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  
  return formatter.format(d);
};

/**
 * Format date to short Thai format
 * @param {Date|string} date 
 * @returns {string} e.g., 1 ม.ค. 69
 */
export const formatThaiDateShort = (date) => {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  
  const formatter = new Intl.DateTimeFormat('th-TH', {
    year: '2-digit',
    month: 'short',
    day: 'numeric',
  });
  
  return formatter.format(d);
};

/**
 * Get relative time string in Thai
 * @param {Date|string} date 
 * @returns {string} e.g., วันนี้, เมื่อวาน, 2 วันที่แล้ว
 */
export const getRelativeTime = (date) => {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  
  const now = new Date();
  const diffTime = now.getTime() - d.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  
  if (diffDays === 0) {
    if (d.getDate() === now.getDate()) {
      return 'วันนี้';
    } else {
      return 'เมื่อวาน';
    }
  }
  
  if (diffDays === 1) return 'เมื่อวาน';
  if (diffDays > 1 && diffDays < 7) return `${diffDays} วันที่แล้ว`;
  
  return formatThaiDateShort(date);
};
